﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidControllerView = void 0;
const ERC20Contract_1 = require("../../contracts/ERC20Contract");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
const App_1 = require("../../App");
const VaultControllerStatusEnum_1 = require("../../enums/VaultControllerStatusEnum");
class LiquidControllerView extends com.CmpUpVaultController {
    constructor(contract) {
        super();
        this._contract = contract;
        this.ctrls.btnInfo.onclick = () => new modalCom.DialogOk("Contract address: " + this._contract.address + "<br><br>" + this.ctrls.lFaqInfo.text, "Info").show();
        this.ctrls.btnRefresh.onclick = () => this.refresh();
        this.ctrls.btnUpdate.onclick = () => this.update();
        this.ctrls.btnUpdate.disable();
        this.ctrls.btnDepositeUSDL.onclick = () => this.depositeUSDL();
        this.ctrls.btnDepositePLS.onclick = () => this.depositePLS();
        // this.ctrls.btnSave.onclick = () => this.saveDumpIndex();
        this._init();
    }
    _init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.lLabel.text = (yield this._contract.id) + "";
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            const needUpdate = yield this._contract.needUpdate();
            if (needUpdate)
                this.ctrls.btnUpdate.enable();
            else
                this.ctrls.btnUpdate.disable();
            const status = parseInt(yield this._contract.getStatus());
            this.ctrls.lStatus.text = VaultControllerStatusEnum_1.VaultControllerStatusEnum[status];
            this.ctrls.lBalance.text = yield this._contract.getBalance();
            this.ctrls.lBalanceUSDL.text = yield this._contract.getBalanceToken(App_1.App.Inst.chain.addressTokenUSDL);
            this.ctrls.lICR.text = parseFloat(yield this._contract.getICR()) * 100 + "";
            this.ctrls.lDebt.text = yield this._contract.getDebt();
            this.ctrls.lColl.text = yield this._contract.getColl();
            const cnf = yield this._contract.getConfig();
            this.ctrls.lTargetICR.text = parseFloat(cnf.targetICR) * 100 + "";
            this.ctrls.lTargetReloanICR.text = parseFloat(cnf.targetReloanICR) * 100 + "";
            this.ctrls.lllMinLoan.text = cnf.llMinLoan;
            this.ctrls.lllGas.text = cnf.llGas;
            this.ctrls.lLoanMinReTakeUSDL.text = cnf.loanMinReTakeUSDL;
            this.ctrls.lSwapMinUSDL.text = cnf.swapMinUSDL;
            this.ctrls.lMaxLoanDumpIndex.text = cnf.maxLoanDumpIndex;
            this.ctrls.lStabPoolSplitPartRever.text = cnf.stabPoolSplitPartRevers;
            this.ctrls.lBuyBurnSplitPartRevers.text = cnf.buyBurnSplitPartRevers;
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            yield this._contract.update();
        });
    }
    // async saveDumpIndex()
    // {
    //     const index = parseFloat(this.ctrls.iDumpIndex.value);
    //     if (!index) return;
    //     this._contract.setMaxSwapDumpIndex(index);
    // }
    depositeUSDL() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            const value = parseFloat(this.ctrls.iValueUSDL.value);
            if (!value)
                return;
            var erc20 = new ERC20Contract_1.ERC20Contract(App_1.App.Inst.chain.addressTokenUSDL, App_1.App.Inst.chain.web3);
            erc20.transfer(this._contract.address, value + "");
        });
    }
    depositePLS() {
        return __awaiter(this, void 0, void 0, function* () {
            yield App_1.App.Inst.chain.getAccountAsync();
            const value = parseFloat(this.ctrls.iValuePLS.value);
            if (!value)
                return;
            this._contract.deposit(value + "");
        });
    }
}
exports.LiquidControllerView = LiquidControllerView;
//# sourceMappingURL=LiquidControllerView.js.map